<template>
    <div>
        <Breadcrumb section-name="Report" :breadcrumb="breadCrumb"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body">
                    <div class="row mb-3 g-2 align-items-end">
                        <div class="col-auto">
                            <a class="btn btn-option" href="javascript:void(0)" @click="downloadFile">
                                <img v-if="!exportLoading" class="print" width="16" height="16"/>
                                <span v-if="exportLoading" class="spinner-border spinner-border-sm" role="status"
                                      aria-hidden="true"></span>
                            </a>
                        </div>
                        <div class="col-md-3 form-group mb-0">
                            <select class="form-control" v-model="params.project_id" name="project_id">
                                <option value="">Select Project</option>
                                <option v-for="each in projects" :value="each.id" v-text="each.name"></option>
                            </select>
                            <div class="invalid-feedback"></div>
                        </div>
                        <div class="col-md-2 form-group mb-0">
                            <flat-pickr
                                class="form-control"
                                placeholder="Start Date"
                                name="start_date"
                                v-model="params.start_date"
                                :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"
                            />
                            <small class="invalid-feedback text-danger"></small>
                        </div>
                        <div class="col-md-2 form-group mb-0">
                            <flat-pickr
                                class="form-control"
                                placeholder="End Date"
                                name="end_date"
                                v-model="params.end_date"
                                :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"
                            />
                            <small class="invalid-feedback text-danger"></small>
                        </div>
                        <div class="col-md-2">
                            <button class="btn btn-inverse-primary w-100" @click="handleSearch">Search</button>
                        </div>
                    </div>

                    <div class="sheet-preview mb-3" v-if="reportData?.date_range">
                        <div class="text-center">
                            <div><strong>Project Name :</strong> {{ projectName }}</div>
                            <div class="fw-bold my-1">Comparison Expense Sheet of Project</div>
                            <div><strong>Report Date Range :</strong> {{ reportData.date_range }}</div>
                        </div>
                    </div>

                    <div class="table-height long-scroll">
                        <table class="table mb-0 table-striped table-bordered dataTable comparison-table">
                            <thead>
                            <tr>
                                <th>Sl</th>
                                <th>Expenses Category</th>
                                <th class="text-center" v-for="name in (reportData.constructions || [])" :key="name">{{ name }}</th>
                                <th class="text-end">Total</th>
                            </tr>
                            </thead>
                            <template v-if="!loading && reportData?.data?.length > 0">
                                <tbody>
                                <tr v-for="(data, index) in reportData.data" :key="data.id">
                                    <td class="text-center">{{ index + 1 }}</td>
                                    <td>{{ data.category_name }}</td>
                                    <td class="text-end" v-for="(amount, i) in data.amounts_format" :key="i">{{ amount }}</td>
                                    <td class="text-end">{{ data.total }}</td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr>
                                    <th class="text-end" colspan="2">Total</th>
                                    <th class="text-end" v-for="(total, i) in reportData.total" :key="i">{{ total }}</th>
                                    <th class="text-end">{{ reportData.grandTotal }}</th>
                                </tr>
                                </tfoot>
                            </template>
                            <template v-if="!loading && (!reportData?.data || reportData.data.length === 0)">
                                <tr class="text-center">
                                    <td colspan="100" class="fw-bold fs-6 text-height">
                                        No Data Found
                                        <br>
                                        Select a project and search.
                                        <br>
                                        Columns = Construction · Rows = Expense Category
                                    </td>
                                </tr>
                            </template>
                            <tbody v-if="loading">
                            <tr>
                                <td colspan="100" class="loader-height">
                                    <Loader></Loader>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "../../Services/ApiService";
import PrintService from "../../Services/PrintService";
import ApiRoutes from "../../Services/ApiRoutes";
import Breadcrumb from "../Common/Breadcrumb.vue";
import Loader from "../Common/Loader.vue";

export default {
    components: {Loader, Breadcrumb},
    data() {
        return {
            breadCrumb: ['Comparison Expense Sheet'],
            reportData: {},
            projects: [],
            params: {
                project_id: '',
                start_date: '',
                end_date: '',
            },
            loading: false,
            exportLoading: false,
        }
    },
    computed: {
        projectName() {
            const project = this.projects.find(p => String(p.id) === String(this.params.project_id));
            return project ? project.name : '';
        }
    },
    methods: {
        buildQuery() {
            const query = new URLSearchParams();
            query.append('project_id', this.params.project_id);
            if (this.params.start_date) {
                query.append('start_date', this.params.start_date);
            }
            if (this.params.end_date) {
                query.append('end_date', this.params.end_date);
            }
            return query.toString();
        },
        downloadFile() {
            if (!this.params.project_id) {
                return;
            }
            PrintService.print('/print/comparison-expense-sheet?' + this.buildQuery());
        },
        fetchProject() {
            ApiService.POST(ApiRoutes.Project + '/list', {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.projects = res.data.data;
                }
            });
        },
        handleSearch() {
            ApiService.ClearErrorHandler();
            this.loading = true;
            ApiService.POST(ApiRoutes.Report + '/comparison-expense-sheet', this.params, (res) => {
                this.loading = false;
                if (parseInt(res.status) === 200) {
                    this.reportData = res;
                } else {
                    ApiService.ErrorHandler(res.errors);
                }
            });
        }
    },
    created() {
        this.fetchProject();
    }
}
</script>

<style scoped>
.sheet-preview {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 12px;
    background: #fff;
    font-size: 14px;
}

.comparison-table th {
    white-space: nowrap;
}

.text-height {
    min-height: 180px;
    padding-top: 24px;
    color: #64748b;
}

.loader-height {
    min-height: 180px;
    padding-top: 24px;
}
</style>
